import IAirline from "@/interfaces/IAirline";
import { atom } from "recoil";

const AirlineListAtom = atom<IAirline[]>({
    default: [],
    key: 'airlineListAtomKey'
})

export default AirlineListAtom;